import React from 'react';
import {
   Row, Col
} from 'reactstrap';
import { SquareCheckbox } from '../Inputs/SquareCheckbox/SquareCheckbox';

function PermissionsTabContent({
    tab,
    activeTab,
    localRolePermissionsDetail,
    system,
    isAppUserRole,
    handleAllCheckboxesToggle,
    renderPermissionCheckboxes,
    isPermissionsListEmpty
}) {
    if (activeTab !== tab) return null;

    const isActiveTabEmpty = isPermissionsListEmpty(tab);

    return (
        <>
            {isActiveTabEmpty ? (
                <p className="text-muted fw-semibold">
                    No permissions configured for this system.
                </p>
            ) : (
                    <>
                        <Row className="align-items-center mt-0 tight-top" style={{ fontSize: '0.9rem' }}>
                            <Col xs="auto" className="pr-0">
                                <SquareCheckbox
                                    value={localRolePermissionsDetail?.permissionList
                                        ?.filter((perm) => perm.systemId === system[activeTab])
                                        .every((perm) => perm.value) ?? false
                                    }
                                    valueChangeHandler={() => handleAllCheckboxesToggle(true)}
                                    isDisabled={false}
                                    id={`chk-all-${tab}`}
                                    label="Allow All"
                                    isInline={true}
                                />
                            </Col>
                            <Col xs="auto" className="pl-0">
                                <SquareCheckbox
                                    value={localRolePermissionsDetail?.permissionList
                                        ?.filter((perm) => perm.systemId === system[activeTab])
                                        .every((perm) => !perm.value) ?? false
                                    }
                                    valueChangeHandler={() => handleAllCheckboxesToggle(false)}

                                    isDisabled={false}
                                    id={`chk-none-${tab}`}
                                    label="Allow None"
                                    isInline={true}
                                />
                            </Col>
                        </Row>


                        <Row className="mt-3" style={{fontSize: '0.9rem'}}>
                        {!isAppUserRole && (
                            <>
                                <Col md={4} className="p-0">
                                    <div className="border h-100">
                                        <h5 className="text-center fw-bold mb-2 mt-2">High Level</h5>
                                        <hr className="w-100 mb-3 mt-0" />
                                        <div className="pt-2 px-4 pb-3">
                                            {renderPermissionCheckboxes('high', activeTab)}
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4} className="p-0">
                                    <div className="border h-100">
                                        <h5 className="text-center fw-bold mb-2 mt-2">Medium Level</h5>
                                        <hr className="w-100 mb-3 mt-0" />
                                        <div className="pt-2 px-4 pb-3">
                                            {renderPermissionCheckboxes('medium', activeTab)}
                                        </div>
                                    </div>
                                </Col>
                            </>
                        )}
                        <Col md={4} className="p-0">
                            <div className="border h-100">
                                <h5 className="text-center fw-bold mb-2 mt-2">Low Level</h5>
                                <hr className="w-100 mb-3 mt-0" />
                                <div className="pt-2 px-4 pb-3">
                                    {renderPermissionCheckboxes('low', activeTab)}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
}

export default PermissionsTabContent;
